module.exports = __webpack_public_path__ + "img/D4C-logo-black.3b2c0eae.png";